import { toast } from "react-hot-toast";
import { actionType } from "../utils/helpers/generalHelper";
import * as EventConstants from "../constants/event.constant";
import EventService from "../services/event.service";
import ErrorHelper from "../utils/helpers/errorHelper";

export const joinEvent = (id, name) => async (dispatch) => {
  try {
    dispatch(actionType(EventConstants.JOIN_EVENT_REQUEST));
    const data = await EventService.joinEvent(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(EventConstants.JOIN_EVENT_SUCCESS, data.data));
    // toast.success(`You have successfully joined ${name}`);
    dispatch(fetchEventAttendees(id));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(EventConstants.JOIN_EVENT_FAILURE));
    toast.error(message);
  }
};

export const leaveEvent = (id, name) => async (dispatch) => {
  try {
    dispatch(actionType(EventConstants.LEAVE_EVENT_REQUEST));
    const data = await EventService.leaveEvent(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(EventConstants.LEAVE_EVENT_SUCCESS, data.data));
    // toast.success(`You have successfully unattended ${name}`);
    dispatch(fetchEventAttendees(id));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(EventConstants.LEAVE_EVENT_FAILURE));
    toast.error(message);
  }
};

export const fetchEvent = (id) => async (dispatch) => {
  try {
    dispatch(actionType(EventConstants.FETCH_EVENT_REQUEST));
    const data = await EventService.fetchById(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(EventConstants.FETCH_EVENT_SUCCESS, data.data));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(EventConstants.FETCH_EVENT_FAILURE));
    toast.error(message);
  }
};

export const fetchEvents = (pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(EventConstants.FETCH_ALL_EVENT_REQUEST));
    const data = await EventService.fetchAll(pageAble);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(EventConstants.FETCH_ALL_EVENT_SUCCESS, data.data.events)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(EventConstants.FETCH_ALL_EVENT_FAILURE));
    toast.error(message);
  }
};

export const fetchEventAttendees = (eventId) => async (dispatch) => {
  try {
    dispatch(actionType(EventConstants.FETCH_EVENT_ATTENDEES_REQUEST));
    const data = await EventService.fetchEventAttendees(eventId);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(
        EventConstants.FETCH_EVENT_ATTENDEES_SUCCESS,
        data.data.students
      )
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(EventConstants.FETCH_EVENT_ATTENDEES_FAILURE));
    toast.error(message);
  }
};

export const createEvent = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(EventConstants.CREATE_EVENT_REQUEST));
    const data = await EventService.create(payload);
    if (data === undefined || data.status !== 201) {
      throw data;
    }
    dispatch(actionType(EventConstants.CREATE_EVENT_SUCCESS, data.data));
    dispatch(fetchEvents());
  } catch (error) {
    let message = "Server error";
    if (error.status === 400) {
      message = error.data.errors[0];
    } else {
      message = ErrorHelper.getApiErrorMessage(error);
    }
    dispatch(actionType(EventConstants.CREATE_EVENT_FAILURE));
    toast.error(message);
  }
};

export const getApproval = (payload) => async (dispatch) => {
  const { id, name, action } = payload;

  try {
    dispatch(
      actionType(EventConstants.EVENT_APPROVAL_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await EventService.approveOrDisapprove(id);
    console.log(data);

    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(EventConstants.EVENT_APPROVAL_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`${name} ${action} successfully.`);
  } catch (error) {
    console.error(error);
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(
      actionType(EventConstants.EVENT_APPROVAL_FAILURE, {
        loading: false,
        id,
      })
    );
    toast.error(message);
  }
};

export const closeModal = () => async (dispatch) => {
  dispatch(actionType(EventConstants.CLOSE_EVENT_MODAL_REQUEST));
};
